"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.amountSpanStyle = exports.amountFieldStyles = void 0;
const amountFieldStyles = ({ palette }) => ({
    inputField: {
        fontWeight: 400,
        whiteSpace: 'nowrap',
        textAlign: 'right',
    },
    red: {
        color: `${palette.amount.negative} !important`,
        whiteSpace: 'nowrap',
    },
    green: {
        color: `${palette.amount.positive} !important`,
        whiteSpace: 'nowrap',
    },
    black: {
        color: `${palette.text.strong} !important`,
        whiteSpace: 'nowrap',
    },
    white: {
        color: palette.text.contrastText,
        whiteSpace: 'nowrap',
    },
    primary: {
        color: palette.primary.main,
        whiteSpace: 'nowrap',
    },
    secondary: {
        color: palette.secondary.main,
        whiteSpace: 'nowrap',
    },
    error: {
        color: palette.primary.error,
        whiteSpace: 'nowrap',
    },
    amountadornment: {
        marginLeft: 0,
        marginRight: 4,
    },
});
exports.amountFieldStyles = amountFieldStyles;
const amountSpanStyle = ({ palette, applyOpacityToHex }) => {
    const root = {
        color: `${palette.text.strong} !important`,
        width: 'fit-content',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: 3,
        verticalAlign: 'middle',
        border: '1px solid transparent',
    };
    return ({
        root,
        normal: Object.assign(Object.assign({}, root), { '&:hover': {
                cursor: 'pointer',
                backgroundColor: applyOpacityToHex(palette.text.strong, 0.1),
            } }),
        focused: Object.assign(Object.assign({ letterSpacing: '0.4px' }, root), { border: `1px solid ${applyOpacityToHex(palette.primary.main, 0.6)}`, backgroundColor: palette.background.paper }),
        editSpan: {
            outlineWidth: 0,
            outlineStyle: 'none',
            minWidth: 4,
            padding: 3,
            paddingRight: 5,
        },
        underlineFocused: Object.assign(Object.assign({ letterSpacing: '0.4px' }, root), { border: `1px solid ${applyOpacityToHex(palette.primary.main, 0.6)}`, backgroundColor: palette.background.paper, borderRadius: 0, borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0 }),
    });
};
exports.amountSpanStyle = amountSpanStyle;
